import type { DismantlingCoefficientTypeEnum } from 'gql/graphql';
import { Tooltip } from 'uikit';

import * as R from 'ramda';
import type React from 'react';
import { useCallback, useRef } from 'react';
import type { UseControllerProps } from 'react-hook-form';
import { useController } from 'react-hook-form';

import { GroupTypesUerSelector } from './GroupTypesUerSelector';

interface IControlGroupTypesUerSelector {
    groupTypeControl: UseControllerProps;
    appliesToUerIdsControl: UseControllerProps;
    label?: string;
    disabled?: boolean;
    disabledIds?: number[];
    isReadOnly?: boolean;
    contractId: number;
    isSelectDisabled?: boolean;
    uerId: number;
}

export const ControlGroupTypesUerSelector: React.FC<IControlGroupTypesUerSelector> = (props) => {
    const {
        groupTypeControl,
        appliesToUerIdsControl,
        label,
        disabled,
        disabledIds,
        contractId,
        isSelectDisabled,
        uerId,
    } = props;

    const { field: groupTypeField, fieldState: groupTypeFieldState } = useController(groupTypeControl);

    const { field: appliesToUerIdsField } = useController(appliesToUerIdsControl);

    const ref = useRef(null);

    const onGroupTypeChange = useCallback(
        (groupType?: DismantlingCoefficientTypeEnum) => {
            groupTypeField.onChange(groupType);
            appliesToUerIdsField.onChange([]);
        },
        [appliesToUerIdsField, groupTypeField],
    );

    const onCheckUerChange = useCallback(
        (checkedIds: number[]) => {
            appliesToUerIdsField.onChange(R.uniq(checkedIds || []));
        },
        [appliesToUerIdsField],
    );

    return (
        <div style={{ position: 'relative' }}>
            <GroupTypesUerSelector
                disabledIds={disabledIds}
                disabled={disabled}
                label={label}
                onGroupTypeChange={onGroupTypeChange}
                status={groupTypeFieldState.invalid ? 'alert' : undefined}
                groupType={groupTypeField.value}
                contractId={contractId}
                checkedUerIds={appliesToUerIdsField.value}
                onCheckUerChange={onCheckUerChange}
                isSelectDisabled={isSelectDisabled}
                uerId={uerId}
            />
            <div ref={ref} style={{ position: 'absolute', right: 0, top: 0, height: '100%' }} />
            {groupTypeFieldState.invalid && groupTypeFieldState.error?.message && (
                <Tooltip size="s" direction="rightCenter" status="alert" anchorRef={ref}>
                    {groupTypeFieldState.error?.message}
                </Tooltip>
            )}
        </div>
    );
};

ControlGroupTypesUerSelector.displayName = 'ControlGroupTypesUerSelector';
